import { CallFrameAppletCapability } from '@doxyme/extensions-bridge';
import {
  type Specs,
  useBasicObservableOptional,
  useCapability,
} from '@doxyme/extensions-bridge-react';
import { bridge } from '../../../features/extensions/instances';

type Applet = Specs.CallFrameApplet.Applet;

/**
 * Hook responsible for providing call frame applets
 */
export function useExtensionsCallApplets(): Applet[] {
  const callFrameApplet = useCapability<CallFrameAppletCapability>(
    bridge,
    CallFrameAppletCapability.id,
  );

  const [applets] = useBasicObservableOptional<Applet[]>(
    [],
    callFrameApplet?.getFrames(),
  );

  return applets;
}
